module.exports = __webpack_public_path__ + "img/opera.89d0a447.svg";